import React, {useMemo, useState} from 'react';
import {Link, useLocation, useParams} from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ServiceSearchCard from '../components/ServiceSearchCard';
import Project from "../../../models/Project";
import ProjectTemplateTagSearch from "../../services/ProjectTemplateTagSearch";
import {useAPI} from "../../../config/API";

const ServiceSearch = (props) => {

    const location = useLocation();
    const params = useParams();

    const [selectedTags, setSelectedTags] = useState([]);
    const selectedCategory = useMemo(() => {
        if (!params.cId) return null;
        let categoryId = parseInt(params?.cId?.replace(/^\D+/g, ''));
        if (!categoryId) return null;

        return TB.find(laravel.project_template_categories, ['id', categoryId]);
    }, [params.cId]);

    const selectService = async(selectedService) => {
        return props.onSubmit({
            id: 'new',
            template: selectedService,
            type: TB.invert(laravel.project_types)[Project.ProjectType.Service]
        });
    }
    const {
        data,
        isFetching,
        error,
        refetch,
    } = useAPI(['fetchServicesByCategory', { category_id: selectedCategory?.id || null, tags: selectedTags }])



    const matchedServices = useMemo(() => {
        if (isFetching || !data) return [];

        // let services = TB.filter(data, service => service.phases?.length > 0);
        // if (selectedCategory) {
        //     return TB.filter(services, ['category.id', selectedCategory?.id])
        // }
        return data
    }, [selectedCategory, isFetching, data]);

    const steps = [
        { order: 1, icon: 'fas fa-thumbs-up', fill: '#8563D7', details: 'Choose a project below' },
        { order: 2, icon: 'fas fa-question', fill: '#4A80E7', details: 'Answer a few questions online to help us understand your specific needs' },
        { order: 3, icon: 'fas fa-users', fill: '#5BE49A', details: 'See teams matched to meet your needs; request proposals' },
        { order: 4, icon: 'fas fa-calendar-alt', fill: '#F4C53E', details: 'Schedule a session with a Wripple Client Lead who will manage scoping, contracting & kick off' },
    ]

    return (
        <div className="py-16 mx-auto max-w-[1200px]">
            <div className="container mx-auto p-2 bg-[#F7F8FA] lg:flex lg:space-x-3 lg:justify-ceter grow-0">

                {steps.map(step => {
                    return (
                        <div key={step.order} className="flex items-start p-2 min-w-[20%]">
                            <div className="mt-0.5 w-8 h-8 shrink-0 flex items-center justify-center" style={TB.createStyledCircle(step.fill)}>
                                <i className={`${step.icon} text-white text-lg`}></i>
                            </div>

                            <div className="pl-2">
                                <p className="font-bold">Step {step.order}</p>
                                <p className="text-xs">{step.details}</p>
                            </div>
                        </div>
                    )
                })}
            </div>


            <div className="container mx-auto bg-white flex flex-col items-stretch px-4 md:px-12 py-7">
                {selectedCategory ? (
                    <React.Fragment>
                        <div className="flex items-center gap-20">
                            {/* <div className="w-16 h-16" style={TB.createStyledCircle(TB.config('color.primary'))} /> */}

                            <img src="/images/dashboard/smart_search_select_team_header.png" className="h-[200px] hidden md:block" alt="" />

                            <div>
                                <p>Teams for:</p>
                                <div className="pt-2 lg:flex lg:space-x-8">
                                    <p className="text-3xl font-semibold">{selectedCategory.name}</p>
                                    <Link to={{pathname: '../', search: "?option-b=1"}} replace
                                          className="btn btn-link btn-link-primary">
                                        Change Category
                                    </Link>
                                </div>
                                <p className="pt-4">
                                     {selectedCategory.description}
                                </p>
                            </div>
                        </div>
                        <div className="pt-9 pb-2">
                            <p className="text-2xl font-medium">Let's find a project type that matches your needs</p>
                        </div>
                    </React.Fragment>
                ) : (
                    <div className="mb-6 flex flex-row justify-between items-center gap-5">
                        <div className="flex-grow max-w-10/12">

                            <p className="pt-9 pb-2 text-2xl font-medium">Smart Search - Find Your Project Type</p>
                            <p className="text-sm">Let’s find a project type that matches your needs.</p>

                        </div>

                        <Link replace to={{pathname: '../', search: "?option-b=1"}}
                              className="ml-auto btn btn-link text-base btn-link-primary">
                            Find Project By Category
                        </Link>

                    </div>
                )}



                <ProjectTemplateTagSearch
                    isDisabled={props.isDisabled}
                    onChange={setSelectedTags}
                    selectedTags={selectedTags}
                />

                <hr />
                {isFetching && (
                    <div className="h-60 flex items-center justify-center">
                        <LoadingSpinner size='lg' />
                    </div>
                )}

                {!isFetching && !error && (
                    <div className="">
                        <p className="font-secondary font-semibold text-base pb-3">{TB.pluralize('Project Type Match', matchedServices?.length, true)}</p>
                        <div className="flex flex-col gap-8 items-stretch">

                            {TB.map(matchedServices || [], (service, index) => (
                                <ServiceSearchCard key={`service-${service.id}`} service={service} index={index} onSelect={() => selectService(service)}/>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ServiceSearch;